import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Loading from "../../Components/Loading/Loading";
import ShowCard from "../../Components/ShowCard/ShowCard";
import { ToastContainer, toast } from "react-toastify";
import { useWindowWidth } from "@react-hook/window-size";
import Translate from "../../Components/Multilanguage/Translate";

import { rowItemCount } from "../../utils/utils";
import * as service from "../MyList/service";

const PlaylistPage = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const isRTL = useSelector((state) => state?.rtl?.isRTL);
  const myListRedux = useSelector((state) => state?.myList?.value);
  const [shows, setShows] = useState([]);
  const [playlistTitle, setPlaylistTitle] = useState("");
  const [loading, setLoading] = useState(true);
  const [thumbnailOrientation, setThumbnailOrientation] = useState("");
  const [rowItemsClass, setRowItemsClass] = useState("");
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;

  const location = useLocation();
  const navigate = useNavigate();
  const { playlistId } = useParams();
  const windowSize = useWindowWidth();

  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };

  useEffect(() => {
    if (
      projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION === "PORTRAIT"
    ) {
      setThumbnailOrientation("PORTRAIT");
    } else {
      setThumbnailOrientation("LANDSCAPE");
    }
  }, [projectInfo]);

  useEffect(() => {
    if (windowSize > 980) {
      if (projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT) {
        setRowItemsClass(rowItemCount(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT));
      } else {
        setRowItemsClass("rowCount4");
      }
    } else {
      setRowItemsClass("");
    }
  }, [projectInfo, windowSize]);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    // Always fetch fresh data from API
    fetchPlaylistData();
  }, [playlistId]);

  const fetchPlaylistData = async () => {
    try {
      const response = await service.fetchWatchlistShows(appInfo);
      if (response?.status === 200) {
        const playlists = response?.data?.data;
        const currentPlaylist = playlists.find(playlist => 
          playlist.playlist_id === parseInt(playlistId)
        );
        
        if (currentPlaylist) {
          setShows(currentPlaylist.shows || []);
          setPlaylistTitle(currentPlaylist.title || "");
          setLoading(false);
        } else {
          // Playlist not found, redirect to favorites
          navigate("/my-list");
        }
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message || "Error loading playlist", {
        position: "bottom-center",
      });
      navigate("/my-list");
    }
  };

  // Sync with Redux myList updates to reflect removed items
  useEffect(() => {
    if (myListRedux && playlistId) {
      const currentPlaylist = myListRedux.find(playlist => 
        playlist.playlist_id === parseInt(playlistId)
      );
      if (currentPlaylist) {
        setShows(currentPlaylist.shows || []);
      }
    }
  }, [myListRedux, playlistId]);

  if (loading) {
    return <Loading />;
  }

  return (
    <div className={`myList ${isRTL ? "rtl" : ""}`}>
      <ToastContainer />

      <div className="wrapper">
        <div className="top">
          <h1 className={`heading ${template === "TEMPLATE_10" ? "gaia" : ""}`}>
            {playlistTitle || <Translate textKey={'my_list'} />}
          </h1>
        </div>
        <div className="bottom">
          <div className="itemsContainer">
            {shows?.map((item, index) => (
              <div 
                key={index}
                className={thumbnailOrientation === `PORTRAIT` ? `items portrait ${rowItemsClass}` : `items landscape ${rowItemsClass}`}
              >
                <ShowCard
                  data={item}
                  imageUrl={true}
                  season={false}
                  metaData={true}
                  modalNavigation={true}
                  showMyListButton={true}
                  fromFavoritesScreen={true}
                  playlistId={playlistId}
                />
              </div>
            ))}
          </div>
          {shows?.length === 0 && (
            <div className="favourite-empty-state">
              <h2><Translate text="no_data_found" /></h2>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PlaylistPage;